import { LoggerService } from '../../core/services/logger.service';
import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserState } from 'src/app/state/user.reducer';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Customer } from 'src/app/core/models/customer.model';
import { selectCurrentCustomer } from 'src/app/state/user.selectors';
import { TranslateService } from '@ngx-translate/core';
import * as UserActions from 'src/app/state/user.actions';

@Component({
    selector: 'app-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.scss'],
    standalone: false
})
export class CompleteComponent implements OnInit, OnDestroy {
  currentCustomer$: Observable<Customer>;
  currentCustomer: Customer;
  currentCustomerSubscription: Subscription;

  constructor(
    private readonly router: Router,
    private readonly logger: LoggerService,
    private readonly store$: Store<UserState>,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentCustomer$ = this.store$.select(selectCurrentCustomer);
    this.currentCustomerSubscription = this.currentCustomer$.subscribe(
      (customer: Customer) => (this.currentCustomer = customer)
    );
  }

  ngOnDestroy(): void {
    this.currentCustomerSubscription.unsubscribe();
  }

  onOk($event: any): void {
    this.store$.dispatch(UserActions.navigateToHome());
  }
}
